import React, { useCallback, useState } from "react";
import { Autocomplete, Text } from "@shopify/polaris";
import {useTranslation} from "react-i18next";
// import { SearchMinor } from "@shopify/polaris-icons";

export default function LocationContainerAutocomplete(props) {
    const { t } = useTranslation();
  const options = props.options
    ? props.options.map((option) => {
        return {
          value: option,
          label: option,
        };
      })
    : [];

  const [locationOptions, setLocationOptions] = useState(options);

  // Filter autocomplete options
  const updateTextFieldValue = useCallback(
    (value) => {
      props.updateValue(value);

      if (value === "") {
        setLocationOptions(options);
        return;
      }

      const filterRegex = new RegExp(value, "i");
      const resultOptions = options.filter((option) =>
        option.label.match(filterRegex)
      );
      setLocationOptions(resultOptions);
    },
    [options]
  );

  let newOptions = [];
  if (
    props.value &&
    !options.map((option) => option.value).includes(props.value)
  ) {
    newOptions = [
      {
        label: (
          <Text variant="bodyMd" as="span">
            <b>{t("common.add")}</b> {props.value}
          </Text>
        ),
        value: props.value,
      },
    ];
  }

  const textField = (
    <Autocomplete.TextField
      label={props.label}
      onChange={updateTextFieldValue}
      value={props.value}
      error={props.error}
      autoComplete="nope"
      ariaAutocomplete="off"
      // prefix={<Icon source={SearchMinor} color="base" />}
    />
  );

  return (
    <Autocomplete
      options={newOptions.concat(locationOptions)}
      selected={props.value || ""}
      onSelect={(selectedOptions) => props.updateValue(selectedOptions[0])}
      textField={textField}
    />
  );
}
